import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import SmartLink from '../SmartLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import SearchBar from './Searchbar';
import styles from './header.module.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import WithAuthorization from '../WithAuthorization';
import exportContentfulAction from '../../store/actions/exportContentfulAction';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#FFFFFF',
  },
  barColorPrimary: {
    backgroundColor: '#ED2E36',
  },
})(LinearProgress);

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      userMenuOpen: false,
      guidelineMenuOpen: false,
    };
    this.headerMobileNavRef = React.createRef();
    this.menuButtonRef = React.createRef();
    this.userMenuRef = React.createRef();
    this.guidelineMenuRef = React.createRef();
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleUserMenuClick = this.handleUserMenuClick.bind(this);
    this.handleGuidelineMenuClick = this.handleGuidelineMenuClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.getContentfulData = this.getContentfulData.bind(this);
  }

  handlePreviewButtonClick = (previewButtonInfo) => {
    previewButtonInfo.onPreviewChange(!previewButtonInfo.isEnabled);
  };
  handleMenuClick() {
    this.setState((prev) => ({
      menuOpen: !prev.menuOpen,
      userMenuOpen: false,
      guidelineMenuOpen: false,
    }));
  }
  handleUserMenuClick() {
    this.setState((prev) => ({
      menuOpen: false,
      userMenuOpen: !prev.userMenuOpen,
      guidelineMenuOpen: false,
    }));
  }
  handleGuidelineMenuClick() {
    this.setState((prev) => ({
      menuOpen: false,
      userMenuOpen: false,
      guidelineMenuOpen: !prev.guidelineMenuOpen,
    }));
  }

  handleClickOutside(event) {
    if (this.menuButtonRef) {
      if (
        this.menuButtonRef.current === event.target ||
        this.menuButtonRef.current.contains(event.target)
      ) {
        this.setState((prev) => ({
          menuOpen: !prev.menuOpen,
          userMenuOpen: false,
          guidelineMenuOpen: false,
        }));
        return;
      }
    }
    if (this.userMenuRef) {
      if (
        this.userMenuRef.current === event.target ||
        this.userMenuRef.current.contains(event.target)
      ) {
        this.setState(() => ({
          menuOpen: false,
          userMenuOpen: true,
          guidelineMenuOpen: false,
        }));
        return;
      }
    }
    if (this.guidelineMenuRef) {
      if (
        this.guidelineMenuRef.current === event.target ||
        (this.guidelineMenuRef.current && this.guidelineMenuRef.current.contains(event.target))
      ) {
        this.setState(() => ({
          menuOpen: false,
          userMenuOpen: false,
          guidelineMenuOpen: true,
        }));
        return;
      }
    }
    this.setState(() => ({
      menuOpen: false,
      userMenuOpen: false,
      guidelineMenuOpen: false,
    }));
  }

  getContentfulData(event) {
    event.preventDefault();
    this.props.fetchContentfulExportAction(this.props.user);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  render() {
    const {
      rootUrl,
      onSearchRequest,
      loginButtonInfo,
      userName,
      firstName,
      previewButtonInfo,
      cxtClassName,
    } = this.props;
    const classes = makeStyles((theme) => ({
      root: {
        flexGrow: 1,
      },
      margin: {
        margin: theme.spacing(1),
      },
    }));

    return (
      <header
        className={`${cxtClassName ? styles[cxtClassName] : ''} ${
          styles.header
        } ${this.state.menuOpen ? styles.navOpen : ''}`}
      >
        <div className={styles.headerTopWrap}>
          <div className={styles.navTopContainer}>
            <div className="row middle-xs">
              <div className="col-xs-9 col-lg-3">
                <SmartLink
                  href={process.env.REACT_APP_PUBLIC_URL}
                  title="ECRI"
                  target="_self"
                >
                  <img
                    rel="preload"
                    className={styles.navLogo}
                    src="https://d84vr99712pyz.cloudfront.net/p/styles/ecri_logo.svg"
                    alt="ECRI"
                    width="251.67px"
                    height="94.38px"
                  />
                </SmartLink>
              </div>
              <div className="col-xs-3 col-lg-9 end-xs">
                <div className={styles.mobileButtons}>
                  <button
                    className={`${styles.navBarToggle} ${
                      this.state.menuOpen ? '' : styles.navBarCollapsed
                    }`}
                    aria-expanded="false"
                    ref={this.menuButtonRef}
                  >
                    <span className={styles.srOnly}>Toggle navigation</span>
                    <span className={`${styles.iconBar} ${styles.topBar}`} />
                    <span className={`${styles.iconBar} ${styles.middleBar}`} />
                    <span className={`${styles.iconBar} ${styles.bottomBar}`} />
                  </button>
                </div>
                <div className={`${styles.navTop} ${styles.showForDesktopUp}`}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/about/`}
                    className={styles.navLink}
                    title="About"
                    target="_self"
                  >
                    About
                  </SmartLink>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/press/`}
                    className={styles.navLink}
                    title="News"
                    target="_self"
                  >
                    News
                  </SmartLink>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/events/`}
                    className={styles.navLink}
                    title="Events"
                    target="_self"
                  >
                    Events
                  </SmartLink>
                  <SmartLink
                    href="https://blog.ecri.org"
                    className={styles.navLink}
                    aria-label="Blog"
                    target="_self"
                  >
                    Blog
                  </SmartLink>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/careers/`}
                    className={styles.navLink}
                    title="Careers"
                    target="_self"
                  >
                    Careers
                  </SmartLink>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/contact/`}
                    className={styles.navLink}
                    title="Contact"
                    target="_self"
                  >
                    Contact
                  </SmartLink>
                  {(window.location.pathname.indexOf("login") !== -1 || (userName && userName !== '')) &&                  
                    <button
                      className={styles.navJoin}
                      onClick={loginButtonInfo.onClick}
                      aria-label={
                        userName && userName !== '' ? 'LOG OUT' : 'LOG IN'
                      }
                    >
                      {userName && userName !== '' ? 'LOG OUT' : 'LOG IN'}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.headerMobileNav} ref={this.headerMobileNavRef}>
          <div className={`${styles.mobileNavContainer} container`}>
            <div
              className={`${styles.mobileNav} ${
                this.state.menuOpen ? '' : styles.navBarCollapsed
              } ${this.state.isSearchMenu ? styles.showSearch : ''}`}
            >
              <ul className={`${styles.navList} ${styles.main}`}>
                <li className={`${styles.navItem} ${styles.itemHeading}`}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/library/`}
                    className={styles.navLink}
                    title="Library"
                    target="_self"
                  >
                    Library
                  </SmartLink>
                </li>
              </ul>
              <ul className={`${styles.navList} ${styles.header}`}>
                <li className={`${styles.navItem} ${styles.firstSubItem}`}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/about/`}
                    className={styles.navLink}
                    title="About"
                    target="_self"
                  >
                    About
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/press/`}
                    className={styles.navLink}
                    title="News"
                    target="_self"
                  >
                    News
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/events/`}
                    className={styles.navLink}
                    title="Events"
                    target="_self"
                  >
                    Events
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <SmartLink
                    href="https://blog.ecri.org"
                    className={styles.navLink}
                    title="Blog"
                    target="_self"
                  >
                    Blog
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/careers/`}
                    className={styles.navLink}
                    title="Careers"
                    target="_self"
                  >
                    Careers
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <SmartLink
                    href={`${process.env.REACT_APP_PUBLIC_URL}/contact/`}
                    className={styles.navLink}
                    title="Contact"
                    target="_self"
                  >
                    Contact
                  </SmartLink>
                </li>
                <li className={styles.navItem}>
                  <button
                    className={styles.navBarButton}
                    onClick={loginButtonInfo.onClick}
                    aria-label="LOG IN"
                  >
                    LOG IN
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={`${styles.headerBottom} ${
            userName && userName !== '' && styles.loggedIn
          }`}
        >
          <div
            className={`${styles.egtNavbar} ${styles.navbarDark} ${styles.navbarContainer}`}
          >
            {window.location.pathname.indexOf("egt-api-") === -1 &&
            <SmartLink
              className={styles.egtNavbarMenuButton}
              href="#"
              onClick={(e) => this.handleGuidelineMenuClick(e)}
              aria-label="Guidelines Menu"
              title="Guidelines Menu"
              target="_self"
            >
              <FontAwesomeIcon icon={faBars} />
            </SmartLink>
            }

            {window.location.pathname.indexOf("egt-api-") === -1 &&
            <Link
              to="/"
              className={styles.navbarBrand}
              aria-label="Guidelines Trust"
            >
              <h3 className={styles.brandHeading}>
                ECRI Guidelines Trust <sup className={styles.trademark}>®</sup>
              </h3>
            </Link>}

            {window.location.pathname.indexOf("egt-api-") !== -1 &&
            <Link
              href={process.env.REACT_APP_PUBLIC_URL}
              className={styles.navbarBrand}
              aria-label="Guidelines Trust"
            >
              <h3 className={styles.brandHeading}>
                ECRI Guidelines Trust <sup className={styles.trademark}>®</sup>
              </h3>
            </Link>}            
              <div className={styles.searchContainerTop}>
                <SearchBar
                  searchId="SearchDesktop"
                  cxtClassName={'headerSearchBar'}
                  onSearchRequest={(sp) => onSearchRequest(sp)}
                />
              </div>
            <ul
              className={`${styles.nav} ${styles.navbarNav} ${styles.navFlexIcons}`}
              onClick={(e) => this.handleUserMenuClick(e)}
            >
              <li
                className={`${styles.navItem} ${styles.dropdown} ${
                  this.state.userMenuOpen ? styles.show : ''
                }`}
              >
                {userName !== '' && (
                  <SmartLink
                    className={`${styles.navLink} ${styles.dropdownToggle} ${styles.navbarAccount}`}
                    href="#"
                    id="navbar-account"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                    aria-label="User Avatar"
                    target="_self"
                  >
                    <span className={styles.userGreeting}>
                      Hello <span className={styles.username}>{firstName}</span>
                    </span>
                  </SmartLink>
                )}
                <div
                  id="userDropdown"
                  className={`${styles.dropdownMenu} ${
                    styles.dropdownMenuRight
                  } ${styles.dropdownInfo} ${
                    this.state.userMenuOpen ? styles.show : ''
                  }`}
                  aria-labelledby="userDropdown"
                  data-dropdown-in="fadeIn"
                  data-dropdown-out="fadeOut"
                  ref={this.userMenuRef}
                >
                  <div>
                    <WithAuthorization authorizedRoles={['previewuser','admin']}>
                      <span className={styles.dropdownDivider} />

                      <div className={styles.switch}>
                        <input
                          className={styles.switchInput}
                          id="previewSwitch"
                          type="checkbox"
                          defaultChecked={previewButtonInfo.isEnabled}
                          onClick={this.handlePreviewButtonClick.bind(
                            this,
                            previewButtonInfo
                          )}
                          aria-label="Preview Switch"
                        />
                        <label
                          className={styles.switchLabel}
                          htmlFor="previewSwitch"
                        >
                          Preview Mode
                        </label>
                      </div>
                    </WithAuthorization>
                    <span className={styles.dropdownDivider} />
                    <WithAuthorization authorizedRoles={['admin']}>
                      <Link
                        id="navbar-export-contentful-page"
                        className={styles.dropdownItem}
                        aria-label="Export Contentful"
                        onClick={this.getContentfulData}
                        to="#"
                      >
                        Export Contentful
                      </Link>
                    </WithAuthorization>
                    <WithAuthorization authorizedRoles={['admin']}>
                      <Link
                        id="navbar-analytics-page"
                        className={styles.dropdownItem}
                        to={`/analytics`}
                        aria-label="Guideline Analytics"
                      >
                        Guideline Analytics
                      </Link>
                    </WithAuthorization>

                    <WithAuthorization authorizedRoles={['admin']}>
                      <Link
                        id="navbar-registration-log-page"
                        className={styles.dropdownItem}
                        to={`/registrationlog`}
                        aria-label="Registration Log"
                      >
                        Registration Log
                      </Link>
                    </WithAuthorization>

                    <WithAuthorization authorizedRoles={['indexer', 'admin']}>
                      <Link
                        id="navbar-indexing-page"
                        className={styles.dropdownItem}
                        to={`/indexing`}
                        aria-label="Guideline Indexing"
                      >
                        Guideline Indexing
                      </Link>
                    </WithAuthorization>
                    <WithAuthorization authorizedRoles={['admin']}>
                      <Link
                        id="navbar-indexing-page"
                        className={styles.dropdownItem}
                        to={`/guidelineroles`}
                        aria-label="Role Management"
                      >
                        Role Management
                      </Link>

                      <span className={styles.dropdownDivider} />
                    </WithAuthorization>
                  </div>

                  <SmartLink
                    id="navbar-static-profile"
                    className={styles.dropdownItem}
                    href={`${rootUrl}/pages/myecri.aspx`}
                    aria-label="My Account"
                    target="_self"
                  >
                    My Account
                  </SmartLink>

                  <SmartLink
                    href="#"
                    id="navbar-static-logout"
                    className={styles.dropdownItem}
                    onClick={loginButtonInfo.onClick}
                    data-overlay="login"
                    aria-label={loginButtonInfo.fullText}
                    target="_self"
                  >
                    {loginButtonInfo.fullText}
                  </SmartLink>
                </div>
              </li>
            </ul>
          </div>
          {userName && userName !== '' && (
            <div className={`${styles.container} ${styles.containerBottom}`}>
              <SearchBar
                searchId="SearchMobile"
                cxtClassName={'headerSearchBar'}
                onSearchRequest={(sp) => onSearchRequest(sp)}
              />
            </div>
          )}
        </div>
        { window.location.href.indexOf("egt-api-") === -1  &&
          (<div
            className={`${styles.container} ${styles.guidelineMenuContainer} ${
              userName && userName !== '' && styles.loggedIn
            }`}
          >
            <div
              id="guidelineMenu"
              className={
                this.state.guidelineMenuOpen
                  ? styles.guidelineMenu
                  : styles.guidelineMenuClosed
              }
            >
              <nav ref={this.guidelineMenuRef}>
                <ul>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="Home"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/about"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="About Guidelines Trust"
                    >
                      About ECRI Guidelines Trust
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/inclusion-criteria"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="Inclusion Criteria"
                    >
                      Inclusion Criteria
                    </Link>
                  </li>
                  <li>
                    <WithAuthorization authorizedRoles={['Reviewer','previewuser','indexer','admin']}>
                      <Link
                        className={styles.guidelineMenuItem}
                        to="/about-trust-scorecard"
                        onClick={() =>
                          this.setState({ guidelineMenuOpen: false })
                        }
                        aria-label="TRUST Scorecard"
                      >
                        TRUST Scorecard
                      </Link>
                    </WithAuthorization>
                  </li>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/search-tips"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="Search Tips"
                    >
                      Search Tips
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/culture"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="Cultural Competence Corner"
                    >
                      Cultural Competence Corner
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={styles.guidelineMenuItem}
                      to="/submit-guidelines"
                      onClick={() =>
                        this.setState({ guidelineMenuOpen: false })
                      }
                      aria-label="Submit Guidelines"
                    >
                      Submit Guidelines
                    </Link>
                  </li>                  
                </ul>
              </nav>
            </div>
          </div>)
        }

{window.location.pathname.indexOf("egt-api-") === -1 &&
        (<div>
          {this.props.loading ? (
            <div className={classes.root}>
              <ColorLinearProgress className={classes.margin} />
            </div>
          ) : (
            ''
          )}
        </div>)}
      </header>
    );
  }
}

Header.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  onSearchRequest: PropTypes.func,
  userName: PropTypes.string,
  loginButtonInfo: PropTypes.shape({
    fullText: PropTypes.string.isRequired,
    mobileText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
};

Header.defaultProps = {
  onSearchRequest: () => {},
  loginButtonInfo: {
    userName: '',
    mobileText: 'LOGIN',
    fullText: 'Log In',
  },
  previewButtonInfo: {
    isEnabled: true,
    isPreviewUser: true,
  },
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...exportContentfulAction,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.oidc.user,
  loading: state.exportContentful.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
